import React from 'react';
import FormSelect from 'react-bootstrap/FormSelect';

interface TimePeriodSelectorProps {
  monthsBack: number;
  onChange: (months: number) => void;
  className?: string;
}

function TimePeriodSelector({ monthsBack, onChange, className }: TimePeriodSelectorProps) {
  return (
    <FormSelect
      value={monthsBack}
      onChange={(e) => onChange(parseInt(e.target.value, 10))}
      className={className}
      size="sm"
      style={{ width: 'auto' }}>
      <option value={1}>Last 1 month</option>
      <option value={2}>Last 2 months</option>
      <option value={3}>Last 3 months</option>
      <option value={6}>Last 6 months</option>
      <option value={12}>Last 12 months</option>
    </FormSelect>
  );
}

export default TimePeriodSelector;
